import * as React from "react"
import { Box } from "@mui/material"

import EditButton from "./EditButton"
import SkipButton from "./SkipButton"


const stylesBox = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: 1
}

export default function actionsColumn(isSkuMappingTable = false) {
	return {
		name: "productID", label: "Actions",
		options: {
			headerAlign: 'center',
			filter: false,
			sort: false,
			customBodyRowRenderLite: (_, rowData) => <Box sx={stylesBox}>
				<EditButton rowData={rowData} isSkuMappingTable={isSkuMappingTable}/>
				<SkipButton rowData={rowData} isSkuMappingTable={isSkuMappingTable} />
			</Box>
		}
	}
}